import type { QuotaEventType, QuotaPeriodClosedReason } from '@shared/schemas/quota';

const QUOTA_EVENT_LABELS: Record<QuotaEventType, string> = {
  account_type_changed: 'Bascule de type de compte',
  auto_renewed: 'Renouvellement automatique',
  blocked: 'Blocage atteint',
  enforcement_toggled: 'Enforcement modifié',
  extra_credit_added: 'Crédit extra ajouté',
  limit_updated: 'Limite mise à jour',
  manual_reset: 'Réinitialisation manuelle',
  quota_configured: 'Quota configuré',
  recomputed: 'Recalcul depuis l’usage',
  renewal_date_updated: 'Date de renouvellement mise à jour',
};

const QUOTA_PERIOD_CLOSED_LABELS: Record<QuotaPeriodClosedReason, string> = {
  manual_reset: 'Réinitialisation manuelle',
  renewal: 'Renouvellement',
};

export function getQuotaEventLabel(eventType: QuotaEventType): string {
  return QUOTA_EVENT_LABELS[eventType];
}

export function getQuotaPeriodClosedLabel(reason: QuotaPeriodClosedReason): string {
  return QUOTA_PERIOD_CLOSED_LABELS[reason];
}
